import { render, staticRenderFns } from "./borcyaslandirma.vue?vue&type=template&id=367e3502"
import script from "./borcyaslandirma.vue?vue&type=script&lang=js"
export * from "./borcyaslandirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports